import { useMutation } from 'react-query';

import { setSubProgramPreferencePartialCompletion as mutationFn } from 'api/endPoints/setSubProgramPreferencePartialCompletion';
import { QueryResponse } from 'api/queries/getSubProgramPreferencePartialCompletion.query';

export const useMutationSetSubProgramPreferencePartialCompletion = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    subProgramId: number;
    option: QueryResponse;
}
